import React, { useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { CheckboxProps } from './types';
import styles from './Checkbox.module.scss';

export function Checkbox({
  checked,
  onChange,
  size = 'md',
  className,
  id,
  label,
  secondary,
  classes,
  ...rest
}: CheckboxProps) {
  const [isChecked, setChecked] = useState(checked ?? false);

  useEffect(() => {
    setChecked(checked);
  }, [checked]);

  const handleCheckboxChange: typeof onChange = (event) => {
    if (onChange) onChange(event);
  };

  return (
    <label htmlFor={id} className={clsx(className, styles.container)}>
      <input
        {...rest}
        id={id}
        className={clsx(
          styles.checkbox,
          { [styles.sm]: size === 'sm' },
          classes?.checkbox
        )}
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      {(label || secondary) && (
        <span
          className={clsx(
            styles.labelWrapper,
            { [styles.sm]: size === 'sm' },
            classes?.labelWrapper
          )}
        >
          {label && (
            <span className={clsx(styles.label, classes?.label)}>{label}</span>
          )}
          {secondary && <span className={styles.secondary}>{secondary}</span>}
        </span>
      )}
    </label>
  );
}
